import { Component } from '@angular/core';
import { Router } from '@angular/router';
import * as firebase from 'firebase';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  
  constructor(private router: Router){}

  ngOnInit(): void {
    console.log('version 001/01')
    this.authenticateUser();
  }

  authenticateUser(){
    firebase.auth().onAuthStateChanged((_user) => {
      if (_user) {
      } else {
        if(!this.router.url.includes("auth/forget-password") && (!this.router.url.includes("login") || !this.router.url.includes("register") || !this.router.url.includes("forget-password") 
        ||!this.router.url.includes("404"))){
          localStorage.clear();
          this.router.navigateByUrl("/auth/login");
        }
      }
    });
  }
}
